import { z } from 'zod'
import errorMap from '@gap/backend/util/validations/validation-error-map'

/** The external calendar an advisor connects. Mirrors the Postgres `calendar_provider` enum. */
export const CalendarProviderSchema = z.enum(['outlook', 'google'], { errorMap })
export type CalendarProvider = z.output<typeof CalendarProviderSchema>

/** How the integration reaches us. Recall is the only source today. */
export const CalendarSourceSchema = z.enum(['recall'], { errorMap })
export type CalendarSource = z.output<typeof CalendarSourceSchema>

/** Integration lifecycle. Mirrors the Postgres `calendar_integration_status` enum. */
export const CalendarIntegrationStatusSchema = z.enum(['connecting', 'connected', 'disconnected', 'error'], { errorMap })
export type CalendarIntegrationStatus = z.output<typeof CalendarIntegrationStatusSchema>

/** Event lifecycle as reported by the provider. Mirrors the Postgres `calendar_event_status` enum. */
export const CalendarEventStatusSchema = z.enum(['confirmed', 'tentative', 'cancelled'], { errorMap })
export type CalendarEventStatus = z.output<typeof CalendarEventStatusSchema>

/** Single occurrence vs recurring series. Mirrors the Postgres `calendar_event_type` enum. */
export const CalendarEventTypeSchema = z.enum(['single', 'recurring'], { errorMap })
export type CalendarEventType = z.output<typeof CalendarEventTypeSchema>
